<template>
  <div class="dynamic-dialog">
    <div class="dynamic-dialog-header">
      <!-- 下拉菜单 -->
      <el-dropdown
        placement="bottom"
        trigger="click"
        class="access-stats-select cp"
        @command="selectDay"
        @visible-change="changeIcon"
      >
        <span class="el-dropdown-link">
          {{ $t(currentDay.value) }}<i
            :class="[isDown ? 'el-icon-arrow-down' : 'el-icon-arrow-up']"
            class="el-icon--right"
          />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="day in days"
            :key="day.id"
            :command="day"
          >
            {{ $t(day.value) }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <!-- 内容 -->
      <div class="access-stats-summary">
        <div
          v-for="item in allDynamics"
          :key="item.index"
          class="access-stats-count"
        >
          <div @click="clickAction(item.action)">
            <span
              class="access-stats-count-label"
              :class="{active:item.action == listType}"
            >{{ $t(item.actionName) }}</span>
          </div>
          <div class="access-stats-count-number">
            <span>{{ item.count }}</span>
          </div>
        </div>
      </div>
    </div>

    <div
      v-loading="loading"
      :element-loading-text="$t('正在加载')"
      element-loading-spinner="icon-loading"
    >
      <div
        v-if="nothing"
        class="no-dynamic"
      >
        <div class="empty-pic" />
        <p class="empty-title">
          {{ $t('还没有动态信息') }}
        </p>
      </div>
      <div
        v-else
        class="access-stats-activity"
        @scroll="loadMore($event)"
      >
        <ul>
          <li
            v-for="timeStamp in timeStamps"
            :key="timeStamp.timeType"
          >
            <h2
              v-if="timeStamp.items.length > 0"
              class="access-stats-timetype"
            >
              {{ $t(timeStamp.timeType) }}
            </h2>
            <ul v-if="timeStamp.items.length > 0">
              <li
                v-for="(item,index) in timeStamp.items"
                :key="index"
                class="access-stats-item"
              >
                <span
                  class="access-stats-username"
                  :title="item.userName"
                >{{ item.userName }}</span>
                <span class="access-stats-action">{{ item.actionZhName }}</span>
                <span class="access-stats-ctime">{{ item.createTime }}</span>
                <span
                  class="access-stats-address"
                  :title="item.location"
                >{{ item.location }}</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <!-- 关闭按钮 -->
    <!-- <div class="dynamic-dialog-footer">
            <button @click="close" class="lv-btn default-btn" >{{$t('关闭')}}</button>
        </div> -->
  </div>
</template>

<script>
import { formatDate, getLanguage } from 'js/util/util.js'
import dayjs from 'dayjs'
import store from 'store'

require('dayjs/locale/zh-cn')
const { getData } = require('js/api/getdata').default

export default {
  props: {
    visible: Boolean,
    listType: String,
    currentDay: Object,
    dynamics: Array,
  },
  data() {
    return {
      days: [
        { id: '7', value: this.$t('7天内') },
        { id: '15', value: this.$t('15天内') },
        { id: '30', value: this.$t('30天内') },
        { id: '45', value: this.$t('45天内') },
        { id: '60', value: this.$t('60天内') },
      ],
      timeStamps: [
        {
          timeType: this.$t('今天'),
          items: [],
        },
        {
          timeType: this.$t('昨天'),
          items: [],
        },
        {
          timeType: this.$t('本周'),
          items: [],
        },
        {
          timeType: this.$t('更早'),
          items: [],
        },
      ],
      allDynamics: [
        { actionName: '全部', action: 'all', count: '' },
      ],
      loading: true, // 正在加载状态展示
      isDown: true, // 下拉菜单icon状态
      limit: 50,
      totalSize: 0,
      renderFinshed: false, // 是否接口请求完成
      loadingMore: false, // 是否正在加载更多
      timeStart: 0, // 0 从今天开始判断  1 从昨天开始判断 3 从这周开始判断 4 直接放入更早

    }
  },
  computed: {
    selectedData() {
      return store.state.curFileInfo
    },
    offset() {
      return this.timeStamps[0].items.length + this.timeStamps[1].items.length + this.timeStamps[2].items.length + this.timeStamps[3].items.length
    },
    nothing() {
      return !this.offset && this.renderFinshed
    },
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.getMeta()
        } else {
          this.clearData()
        }
      },
      immediate: true,
    },
    renderFinshed(val) {
      if (val) this.loadingMore = false
    },
  },
  methods: {
    /**
         * 获取是否区间
         */
    compareDate(targetDate, standaraDate) {
      let tarYear; let tarMonth; let tarDate
      let stanYear; let stanMonth; let
        stanDate
      if (!standaraDate) standaraDate = new Date()
      targetDate = new Date(targetDate)
      standaraDate = new Date(standaraDate)

      // 获取目标时间的年月日
      tarYear = targetDate.getFullYear().toString()
      tarMonth = (targetDate.getMonth() + 1).toString()
      tarDate = targetDate.getDate().toString()

      // 获取标准时间的年月日
      stanYear = standaraDate.getFullYear().toString()
      stanMonth = (standaraDate.getMonth() + 1).toString()
      stanDate = standaraDate.getDate().toString()

      return {
        isToday() {
          return (tarYear == stanYear) && (tarMonth == stanMonth) && (tarDate == stanDate)
        },
        isYesterday() {
          const yesterday = standaraDate
          yesterday.setDate(yesterday.getDate() - 1)
          const year = yesterday.getFullYear().toString()
          const month = (yesterday.getMonth() + 1).toString()
          const date = yesterday.getDate().toString()
          return (tarYear == year) && (tarMonth == month) && (tarDate == date)
        },
        isThisWeek() {
          const tarCount = dayjs(new Date(targetDate)).valueOf()
          const language = getLanguage() === 'zh' ? 'zh-cn' : 'en'
          dayjs.locale(language)
          const thisWeekStart = dayjs().startOf('week').valueOf()
          const thisWeekEnd = dayjs().endOf('week').valueOf()
          return tarCount >= thisWeekStart && tarCount <= thisWeekEnd
        },
        isLastWeek() {
          const oneDayTime = 1000 * 60 * 60 * 24
          const tarCount = parseInt(targetDate.getTime() / oneDayTime)
          const stanCount = parseInt(standaraDate.getTime() / oneDayTime)
          return parseInt((tarCount + 4) / 7) == parseInt((stanCount + 4) / 7) - 1
        },
        isThisMonth() {
          return (tarYear == stanYear) && (tarMonth == stanMonth)
        },
        isLastMonth() {
          const lastMonth = standaraDate
          lastMonth.setMonth(lastMonth.getMonth() - 1)
          const year = lastMonth.getFullYear().toString()
          const month = (lastMonth.getMonth() + 1).toString()
          return (tarYear == year) && (tarMonth == month)
        },
      }
    },
    /**
         * 获取内容详情
         */
    getMeta() {
      const { neid, nsid }= this.selectedData
      const params = {
        days: this.currentDay.id,
        neid,
        nsid,
        type: this.listType,
        limit: this.limit,
        offset: this.offset,
      }
      getData('fileDynamicsDetail', params).then((ret) => {
        this.totalSize = ret.data.count
        this.allDynamics.splice(1, 4, ...this.dynamics)
        for (let i = 0; i < ret.data.detail.length; i++) {
          const data = this.changeData(ret.data.detail[i])
          if (this.compareDate(data.ctime).isToday()) {
            this.timeStamps[0].items.push(data)
          } else if (this.compareDate(data.ctime).isYesterday()) {
            this.timeStamps[1].items.push(data)
          } else if (this.compareDate(data.ctime).isThisWeek()) {
            this.timeStamps[2].items.push(data)
          } else {
            this.timeStamps[3].items.push(data)
          }
        }
        this.loading = false
        this.renderFinshed = true
        this.loadingMore = false
      }).catch((err) => {
        this.loading = false
      })
    },
    /**
         * 分页加载
         */
    loadMore(e) {
      const { target } = e
      if ((target.clientHeight + target.scrollTop) >= (target.scrollHeight - 50) && !this.loadingMore && this.offset != this.totalSize && this.offset != 0) {
        this.loadingMore = true
        this.getMeta()
      }
    },

    selectDay(day) {
      this.$emit('getMeta', day)
      this.clearData()
      this.$nextTick(() => {
        this.getMeta()
      })
    },
    // close() {
    //     this.$emit('closeDialog')
    // },
    clickAction(type) {
      this.$emit('changeListType', type)
      this.clearData()
      this.$nextTick(() => {
        this.getMeta()
      })
    },
    changeData(data) {
      switch (data.type) {
        case 0:
          data.actionZhName = this.$t('预览')
          break
        case 1:
          data.actionZhName = this.$t('下载')
          break
        case 3:
          data.actionZhName = this.$t('评论')
          break
        case 5:
          data.actionZhName = this.$t('移动')
          break
        case 6:
          data.actionZhName = this.$t('复制')
          break
        case 7:
          data.actionZhName = this.$t('重命名')
          break
        case 9:
          data.actionZhName = this.$t('删除')
          break
        case 10:
          data.actionZhName = this.$t('还原')
          break
        case 8:
          data.actionZhName = this.$t('收藏')
          break
        case 4:
          data.actionZhName = this.$t('链接')
          break
        default:
          data.actionZhName = this.$t('更新')
          break
      }
      data.createTime = formatDate(new Date(data.ctime), 'yyyy-MM-dd hh:mm:ss')
      return data
    },
    clearData() {
      this.timeStamps.forEach((timeStamp) => {
        timeStamp.items = []
      })
      this.loading = true
      this.renderFinshed = false
    },
    changeIcon(v) {
      this.isDown = !v
    },
  },
}
</script>

<style lang="less" scoped>
@import '~less/button.less';
.dynamic-dialog {
  width: 520px;
  height: 100%;
  color: #1B2733;
  font-family: "PingFangSC-Regular", "microsoft yahei", "微软雅黑", "Hiragino Sans GB";
}
.dynamic-dialog-header {
  padding: 10px 20px 0 20px;
  .access-stats-select {
    color: #050F28;
  }
  .access-stats-summary {
    height: 52px;
    margin-top: 22px;
    margin-bottom: 15px;
    .access-stats-count {
      float: left;
      height: 52px;
      text-align: center;
      width: 96px;
      .access-stats-count-label {
        padding: 3px 10px;
        border-radius: 2px;
        cursor: pointer;
      }
      .access-stats-count-number {
        color: #637282;
        margin-top: 12px;
      }
      .active{
        border: 0;
        background: #F0F2F6;
        color: #0A64FA;
      }
    }
  }
}
.icon-loading{
  background-image:url("~image/search-load.gif");
}
.no-dynamic {
  text-align: center;
  margin-top: 80px;
  .empty-pic {
    width: 95px;
    height: 130px;
    display: inline-block;
    background-image: url("../images/dynamic-empty.svg");
    background-repeat: no-repeat;
  }
  .empty-title {
    color: #237bf8;
    font-size: 14px;
    margin-top: 20px;
    text-align: center;
  }
}
.access-stats-activity {
  overflow-y: auto;
  height: 310px;
  padding: 0 12px 0 20px;
  margin-right: 8px;
  .access-stats-timetype {
    background: #F0F2F6;
    height: 24px;
    line-height: 24px;
    padding-left: 5px;
    font-size: 12px;
    color: #637282;
  }
  .access-stats-item {
    height: 36px;
    line-height: 36px;
    padding-left: 8px;
    padding-right: 8px;
    border-bottom: 1px solid rgba(192, 198, 205, 0.4);
    span {
      display: inline-block;
    }
    .access-stats-username {
      width: 145px;
      overflow: hidden;
      vertical-align: bottom;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .access-stats-action {
      margin-left: 8px;
      width: 75px;
    }
    .access-stats-ctime {
      width: 145px;
      white-space: nowrap;
    }
    .access-stats-address {
      max-width: 65px;
      overflow: hidden;
      vertical-align: bottom;
      text-overflow: ellipsis;
      white-space: nowrap;
      float: right;
    }
  }
  .access-stats-item:last-child {
    border:none;
  }
}
.access-stats-activity::-webkit-scrollbar {
  width: 6px;
  height: 4px;
}
.access-stats-activity::-webkit-scrollbar-thumb {
  margin-left: 20px;
  background: #C1C7CD;
  border-radius: 3px;
}
</style>
